import { ExtraInputFields } from "../Admin/CategoriesAndServicesTable/mapExtraInputFields";

export function validateExtraInput(
  value: string,
  settings: ExtraInputFields,
): { ok: boolean; message?: string } {
  const trimmed = value.trim();
  if (settings.extraInputRequired && !trimmed) {
    return { ok: false, message: "Необходимо заполнить поле" };
  }
  if (!trimmed) {
    return { ok: true };
  }
  if (trimmed.length > 128) {
    return { ok: false, message: "Превышен лимит символов" };
  }
  if (settings.extraInputDigitsOnly && !/^\d+$/.test(trimmed)) {
    return { ok: false, message: "Можно вводить только цифры" };
  }
  if (settings.extraInputLettersOnly && !/^\p{L}+$/u.test(trimmed)) {
    return { ok: false, message: "Можно вводить только буквы" };
  }
  const minLength = settings.extraInputMinLength;
  const maxLength = settings.extraInputMaxLength;
  if (minLength != null && trimmed.length < minLength) {
    return {
      ok: false,
      message: `Введите не менее ${minLength} символов`,
    };
  }
  if (maxLength != null && trimmed.length > maxLength) {
    return {
      ok: false,
      message: `Введите не более ${maxLength} символов`,
    };
  }
  return { ok: true };
}

export function filterExtraInputChars(
  value: string,
  settings: ExtraInputFields,
): string {
  let next = value;
  if (settings.extraInputDigitsOnly) {
    next = next.replace(/\D/g, "");
  } else if (settings.extraInputLettersOnly) {
    next = next.replace(/[^\p{L}]/gu, "");
  }
  const maxLength = settings.extraInputMaxLength ?? 128;
  return next.slice(0, Math.min(maxLength, 128));
}
